<template>
  <div>
    <Header />
    <About />
    <Implementors />
    <Demo />
  </div>
</template>

<script>
import Header from "./Header";
import About from "./About";
import Implementors from "./Implementors";
import Demo from "./Demo";
export default {
  name: "Main",
  components: { Demo, Implementors, About, Header},
  created() {
    this.$store.commit("SET_PAGE_TYPE", "alex");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    // console.log(
    //   "Background Color",
    //   this.$store.state.pageFooterBackgroundColor
    // );
  }
};
</script>

<style scoped>
</style>
